import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import './Sign.css'

class Sign extends Component {
  render() {
    return (
      <div className="Sign">
        <NavLink to="/login" activeStyle={{ opacity: 1 }}>Sign in</NavLink>
        <div />
        <NavLink to="/register" activeStyle={{ opacity: 1 }}>Sign up</NavLink>
      </div>
    );
  }
}

export default Sign;


// WEBPACK FOOTER //
// ./src/Containers/GetStarted/Sign.js